import { render, staticRenderFns } from "./CasosCustomCols.vue?vue&type=template&id=4ea0557f&"
import script from "./CasosCustomCols.vue?vue&type=script&lang=js&"
export * from "./CasosCustomCols.vue?vue&type=script&lang=js&"
import style0 from "./CasosCustomCols.vue?vue&type=style&index=0&id=4ea0557f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports